module.exports = __webpack_public_path__ + "img/bonscheladen.20ffeac5.webp";